import { useEffect, useState } from "react";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

type PdfDocState = {
  doc: pdfjsLib.PDFDocumentProxy | null;
  numPages: number;
  loading: boolean;
  error: string | null;
};

export const usePdfDocument = (url: string): PdfDocState => {
  const [state, setState] = useState<PdfDocState>({
    doc: null,
    numPages: 0,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    let loadingTask: pdfjsLib.PDFDocumentLoadingTask | null = null;

    setState({ doc: null, numPages: 0, loading: true, error: null });

      loadingTask = pdfjsLib.getDocument({ url, withCredentials: false });

    loadingTask.promise
      .then((doc) => {
        if (cancelled) {
          doc.destroy();
          return;
        }
        setState({ doc, numPages: doc.numPages, loading: false, error: null });
      })
            .catch((err) => {
        if (cancelled) return;
        console.error("[usePdfDocument] failed to load", url, err);
        const message =
          err?.name === "PasswordException"
            ? "This PDF is password-protected and can't be previewed."
            : "This file couldn't be opened as a PDF.";
        setState({ doc: null, numPages: 0, loading: false, error: message });
      });

    return () => {
      cancelled = true;
      loadingTask?.destroy();
    };
  }, [url]);

  useEffect(() => {
    return () => {
      state.doc?.destroy();
    };
  }, [state.doc]);

  return state;
};